export default __webpack_public_path__ + "static/about-img-58d2ebe71589371fe14aa3a76cec84e0.svg";